module.exports = __webpack_public_path__ + "static/media/user.0c93cd79.svg";